module.exports = __webpack_public_path__ + "static/media/Juelich_Blogs.d1ecb7bc.png";